import { SelectOption } from '@/components/form-builder/form-builder.types';
import { FundingDto } from '@/types';
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { Observable, of } from 'rxjs';
import { Select } from 'primeng/select';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'sm-paa-funding-source-form',
  imports: [InputTextModule, InputNumberModule, ButtonModule, CommonModule, FormsModule, TranslateModule, Select, ConfirmDialog],
  templateUrl: './funding-source-form.component.html',
  styleUrl: './funding-source-form.component.scss',
  providers: [ConfirmationService],
})
export class PaaFundingSourceFormComponent implements OnInit {
  @Input() value: Observable<FundingDto[]> = of([]);
  @Input() onChange?: (event: FundingDto[]) => void;
  @Input() errors: Observable<{ sourceFinancement: string; monnaieId: string; budgetEstimer: string }[]> = of([]);
  @Input() disabled = of(false);
  @Input() globalError: Observable<string> = of('');

  @Input() currencyOptions: SelectOption[] = [];
  @Input() financialSourcesOptions: SelectOption[] = [];

  private confirmationService = inject(ConfirmationService);
  private translate = inject(TranslateService);

  fundings: FundingDto[] = [];
  uid = new Date().getTime();

  ngOnInit() {
    this.value.subscribe(slots => {
      this.fundings = (slots || []).map(slot => ({ ...slot }));
    });
  }

  addFunding() {
    this.fundings.push({ monnaieId: undefined, sourceFinancement: { id: undefined }, budgetEstimer: undefined });
    this.onChange?.([...this.fundings]);
  }

  updateMonnais(index: number, newValue: number) {
    this.fundings[index].monnaieId = newValue;
    this.onChange?.([...this.fundings]);
  }

  updateSourceFinancement(index: number, newValue: number) {
    this.fundings[index].sourceFinancement = { id: newValue };
    this.onChange?.([...this.fundings]);
  }

  updateBudget(index: number, newValue: number) {
    this.fundings[index].budgetEstimer = newValue;
    this.onChange?.([...this.fundings]);
  }

  removeFunding(index: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('confirm_delete.funding_source'),
      header: this.translate.instant('confirmation'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translate.instant('common.dialog.confirm'),
      rejectLabel: this.translate.instant('common.dialog.cancel'),
      accept: () => {
        this.fundings.splice(index, 1);
        this.onChange?.([...this.fundings]);
      },
    });
  }

  clearAllFundings() {
    this.confirmationService.confirm({
      message: this.translate.instant('confirm_delete.funding_sources'),
      header: this.translate.instant('confirmation'),
      acceptLabel: this.translate.instant('common.dialog.confirm'),
      rejectLabel: this.translate.instant('common.dialog.cancel'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.fundings = [];
        this.onChange?.([]);
      },
    });
  }

  trackByFn(index: number) {
    return index;
  }
}
